import React,{useEffect} from 'react'
import { NavLink } from 'react-router-dom';
import { useAappContext } from '../context/AppContext'
import "../PageCss/Product.css"; 
import SHA256 from 'crypto-js/sha256';




const ProductS = (curElem) => {
    const{getApiHost,ApiHost,reload,reloaddata}=useAappContext()

    useEffect(()=>{
      getApiHost()
    },[])

const {id:pid,image,name}=curElem;

  return (
    <>
    
    <div  className="product" title="Click to Display Product Info" onClick={()=> reloaddata(pid, !reload) }>
    <NavLink to={`/product/${pid}`}>
      
      <div className="pconent">
        <img src={ApiHost+image} alt="" />
        {/* 
         */}
      </div>
      </NavLink>
      <div className="pinfo">
      <h3 style={{fontSize:16,margin:'0px 0px 8px 0px',letterSpacing:'0.03rem'}}>{name}</h3>
      <NavLink to={`/product/${pid}`}><button onClick={()=> reloaddata(pid, !reload) } style={{marginBottom:10}} className="normal p-details-btn">Details</button></NavLink> 
      </div> 
      </div>
      
      
    
    </>
  )
}
export default ProductS